import React, { PureComponent } from "react";

import RGTimeoutComponent from "@tvg/rg-timeout";
import Routes from "./Routes";

import perf from "../utils/perf";

const OPTIONS_IDX_DEFAULT = 0;
const TIMEOUT_KEY = "rgTimeout";
const SELF_EXCLUDE_KEY = "rgSelfExclude";
const SUSPEND_ACCOUNT_KEY = "rgSuspendAccount";
const OPTIONS_KEYS = [TIMEOUT_KEY, SELF_EXCLUDE_KEY, SUSPEND_ACCOUNT_KEY];
const TIMEOUT_EXCLUSIONS_ROUTES = Routes.filter((route) =>
  OPTIONS_KEYS.includes(route.key)
);

export const getRouteConfig = (locationPathname) => {
  const [routeConfig] = TIMEOUT_EXCLUSIONS_ROUTES.filter(
    (route) => route.path === locationPathname
  );
  return routeConfig;
};

class RGTimeout extends PureComponent {
  static defaultProps = {
    device: "mobile",
    currentPath: ""
  };

  componentDidUpdate() {
    perf.measure("page_render", { page: "rg-timeout" });
  }

  render() {
    const routeConfig = getRouteConfig(this.props.currentPath);
    const optionsIdxSelected = routeConfig
      ? OPTIONS_KEYS.indexOf(routeConfig.key)
      : OPTIONS_IDX_DEFAULT;
    return (
      <RGTimeoutComponent
        {...this.props}
        device={this.props.device}
        optionsIdxSelected={optionsIdxSelected}
      />
    );
  }
}

export default RGTimeout;
